<script setup>
/** 列表页顶部的搜索框、筛选框和排序框；`view` 来自 useListView。 */
import { useI18n } from 'vue-i18n'
import { Input, Select } from '@drama/ui'

defineProps({ view: { type: Object, required: true } })
const { t } = useI18n()
</script>

<template>
  <div class="voko-list-toolbar">
    <Input v-model="view.state.search" type="search" :placeholder="t('list.search')" :aria-label="t('list.search')" />
    <Select v-for="filter in view.filters" :key="filter.key" v-model="view.state.filters[filter.key]" :aria-label="filter.label" :options="[{ value: '', label: filter.label }, ...filter.options]" size="sm" />
    <Select v-if="view.sorts.length > 0" v-model="view.state.sort" :aria-label="t('list.sort')" :options="view.sorts.map((sort) => ({ value: sort.value, label: sort.label }))" size="sm" />
  </div>
</template>

<style scoped>
.voko-list-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: var(--drama-space-sm);
  margin-bottom: var(--drama-space-md);
}
</style>
